import { _t, _locale } from "@/lib/i18n";
export const CATEGORIES = [
  { id: "figli", label: _t("Per i miei figli"), desc: _t("Un pensiero che li accompagni negli anni."), theme: "sunset" },
  { id: "nipoti", label: _t("Per i miei nipoti"), desc: _t("Piccole radici da tramandare."), theme: "aurora" },
  { id: "cara", label: _t("Per una persona cara"), desc: _t("Un ricordo dedicato a chi ami."), theme: "orbit" },
  { id: "amore", label: _t("Per un vecchio amore"), desc: _t("Ciò che il tempo ha lasciato."), theme: "nebula" },
  { id: "amico", label: _t("Per un nuovo amico"), desc: _t("Un dono che inizia oggi."), theme: "orbit" },
  { id: "posteri", label: _t("Per i posteri"), desc: _t("Un messaggio per chi verrà."), theme: "aurora" },
  { id: "me_stesso", label: _t("Per me stesso"), desc: _t("Un ponte con il tuo io futuro."), theme: "sunset" },
  { id: "personalizzata", label: _t("Capsula personalizzata"), desc: _t("Definisci tu il senso."), theme: "orbit" },
];

export const COVER_THEMES = [
  { id: "orbit", label: _t("Orbita"), className: "cover-orbit" },
  { id: "sunset", label: _t("Tramonto"), className: "cover-sunset" },
  { id: "aurora", label: _t("Aurora"), className: "cover-aurora" },
  { id: "nebula", label: _t("Nebulosa"), className: "cover-nebula" },
];

export const STATE_LABEL = {
  BOZZA: _t("Bozza"),
  PROGRAMMATA: _t("Programmata"),
  RIPENSAMENTO_24H: _t("Ripensamento"),
  IN_VIAGGIO: _t("In viaggio"),
  DISPONIBILE: _t("Disponibile"),
  APERTA: _t("Aperta"),
  ANNULLATA: _t("Annullata"),
  REVOCATA: _t("Revocata"),
  SCADUTA_O_NON_RECAPITABILE: _t("Non recapitabile"),
};

export const STATE_PILL_CLASS = {
  BOZZA: "pill-bozza",
  PROGRAMMATA: "pill-viaggio",
  RIPENSAMENTO_24H: "pill-ripensamento",
  IN_VIAGGIO: "pill-viaggio",
  DISPONIBILE: "pill-disponibile",
  APERTA: "pill-aperta",
  ANNULLATA: "pill-annullata",
  REVOCATA: "pill-annullata",
  SCADUTA_O_NON_RECAPITABILE: "pill-annullata",
};

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(_locale(), {
      day: "2-digit", month: "long", year: "numeric", ...opts,
    });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(_locale(), {
      day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export function formatBytes(n) {
  if (!n) return "0 B";
  const k = 1024, sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(n) / Math.log(k));
  return `${(n / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
}
